"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Anchor;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@sart/styles");
var _Text = _interopRequireDefault(require("./Text"));
var _excluded = ["title", "style", "disabled", "disabledStyle"];
function Anchor(props) {
  var title = props.title,
    style = props.style,
    disabled = props.disabled,
    disabledStyle = props.disabledStyle,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var textStyles = [styles["default"], style, disabled && styles.disabled, disabled && disabledStyle];
  function openInNewTab(link) {
    window.open(link, '_blank');
  }
  return /*#__PURE__*/_react["default"].createElement(_Text["default"], (0, _extends2["default"])({
    style: textStyles,
    accessibilityRole: "link"
  }, rest), title);
}
Anchor.propTypes = {
  title: _propTypes["default"].string.isRequired,
  disabled: _propTypes["default"].bool,
  style: _propTypes["default"].any,
  disabledStyle: _propTypes["default"].any
};
var styles = _reactNative.StyleSheet.create({
  "default": {
    color: _styles.colors.feature
  },
  disabled: {
    color: _styles.colors.trivial
  }
});